module.exports = __webpack_public_path__ + "static/media/F12-jQuery.fff3390a.svg";